export const services = [
  {
    title: 'Digital Printing Machines',
    description:
      'High-performance VICTORY brand printers — eco-solvent, UV flatbed, and large-format machines built for heavy-duty production.',
  },
  {
    title: 'VisionJet Inks & Consumables',
    description:
      'Authorized dealer for VisionJet premium inks. Consistent colour, high durability, and cost-effective performance for every print job.',
  },
  {
    title: 'Installation & Commissioning',
    description:
      'End-to-end machine setup, calibration, and training so your team is production-ready from day one.',
  },
  {
    title: 'Service & Annual Maintenance',
    description:
      'Preventive maintenance, spare parts supply, and rapid-response technical support to maximise uptime.',
  },
]

export const industries = [
  'Signage & Advertising',
  'Textile Printing',
  'Interior Decoration',
  'Vehicle Wrapping',
  'Industrial Marking',
]

export const processSteps = [
  {
    step: '01',
    title: 'Consult',
    description:
      'We understand your production needs, volume, and budget to recommend the right VICTORY machine.',
  },
  {
    step: '02',
    title: 'Demo',
    description:
      'Live machine demonstration at our Bengaluru showroom — see print quality and speed first-hand.',
  },
  {
    step: '03',
    title: 'Install',
    description:
      'Professional installation, calibration, and hands-on operator training at your site.',
  },
  {
    step: '04',
    title: 'Support',
    description:
      'Ongoing maintenance, genuine spare parts, and priority technical support to keep you running.',
  },
]

export const achievements = [
  { metric: '50+', label: 'Machines Installed' },
  { metric: '2024', label: 'Founded In' },
  { metric: '100+', label: 'Happy Clients' },
  { metric: '24/7', label: 'Service Support' },
]

export const productCategories = [
  { name: 'Solvent Printers', desc: 'High-speed, large-format solvent printers for outdoor signage, banners, and flex printing with vibrant, weather-resistant output.', img: '/categories/solvent-printer.png' },
  { name: 'Eco-Solvent Printers', desc: 'Environmentally friendly printing with low-odour inks — ideal for indoor graphics, wallpapers, and vehicle wraps.', img: '/categories/eco-solvent-printer.png' },
  { name: 'UV Printers', desc: 'Flatbed and roll-to-roll UV printers for rigid and flexible media — print directly on wood, acrylic, glass, and more.', img: '/categories/uv-printer.png' },
  { name: 'CNC Routers', desc: 'Precision CNC cutting and engraving machines for wood, acrylic, MDF, aluminium, and composite materials.', img: '/categories/cnc-router.png' },
  { name: 'CO2 Lasers', desc: 'CO2 laser cutting and engraving for acrylic, leather, fabric, paper, and non-metal materials with fine detail.', img: '/categories/co2-laser.png' },
  { name: 'Laminators', desc: 'Hot and cold laminating machines for protecting and finishing printed media — glossy, matte, and textured options.', img: '/categories/laminator.png' },
  { name: 'Inks & Consumables', desc: 'Solvent, eco-solvent, and UV inks for all print head types. Plus spare parts, dampers, and accessories.', img: '/categories/inks-consumables.png' },
]

export const testimonials = [
  {
    quote:
      'The VICTORY printer we purchased from SJS Technology has been running non-stop for months. Excellent print quality and the after-sales support is top-notch.',
    author: 'Signage Business Owner, Bengaluru',
  },
  {
    quote:
      'SJS Technology helped us choose the right machine for our textile printing needs. Installation was smooth and the team trained our operators thoroughly.',
    author: 'Production Manager, Textile Unit',
  },
]
